define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 距离单位。
     *
     * @exports EnumMeasureUnit
     * 
     * @see DistanceMeasure#unit
    */
    var EnumMeasureUnit = {
        /**
         * 厘米。
         * @type {String}
         * @constant
         */
        CENTIMETER: "CENTIMETER",

        /**
         * 米。
         * @type {String}
         * @constant
         */
        METER: "METER",

        /**
         * 千米。
         * @type {String}
         * @constant
         */
        KILOMETER: "KILOMETER",

        /**
         * 海里。
         * @type {String}
         * @constant
         */
        NAUTICAL_MILE: "NAUTICAL_MILE",
    }
    freezeObject(EnumMeasureUnit)

    /**
     * 反向查找距离单位的名称。
     * 
     * @param {String} value 距离单位的数值。
     * @returns {String} 距离单位的名称。
     */
    function getName(value) {
        for (var key in EnumMeasureUnit) {
            if (EnumMeasureUnit.hasOwnProperty(key) && EnumMeasureUnit[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        CENTIMETER: "CENTIMETER",
        METER: "METER",
        KILOMETER: "KILOMETER",
        UNIT_KILOMETER: "NAUTICAL_MILE",
        getName: getName
    }
})